import { createStyles } from '../../core/withStyles';
import { marginBetweenChildrenHorizontal } from '../../mixins';
const styles = (theme) => createStyles({
    root: Object.assign({ display: 'flex', width: '100%' }, marginBetweenChildrenHorizontal(theme.spacing(1))),
    clickable: {
        cursor: 'pointer',
    },
    inline: {
        display: 'inline-flex',
        width: 'auto',
    },
    center: {
        display: 'flex',
        alignItems: 'center',
    },
    halfMargin: Object.assign({}, marginBetweenChildrenHorizontal(theme.spacing(0.5))),
    doubleMargin: Object.assign({}, marginBetweenChildrenHorizontal(theme.spacing(2))),
});
export default styles;
//# sourceMappingURL=Row.styles.js.map